"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
function NoResults(_a) {
    var title = _a.title, linkText = _a.linkText, linkClickHandler = _a.linkClickHandler;
    return (react_1.default.createElement("div", { className: "lead has-no-results" },
        react_1.default.createElement("h2", null, title),
        react_1.default.createElement("a", { className: "link", onClick: function () { return linkClickHandler(); } }, linkText)));
}
exports.default = NoResults;
